import { axiosPost, axiosPatch, handleOnError } from '../utils/api';

class PreferencesService {
    async update(data){
        try{
            let response = await axiosPatch('users/preference',data);
            return response.data
          }catch(error){
            return await handleOnError(error);
        }
    }
    async resetPreferences(){
        try{
            let response = await axiosPost('users/preference/reset',{});
            return response.data
          }catch(error){
            return await handleOnError(error);
        }
    }
}

export default new PreferencesService();